import React from "react";
import { initialAppData } from "./InitialAppDataContext.d";
import { CountryCode } from "../../utils/CountryCode";
const InitialAppData: initialAppData = {
	locations: [],
	userInformation: {
		country: CountryCode.AU,
		roles: [],
		ipAddress: "",
		didDefaultCountry: false
	}
};
export const InitialAppDataContext = React.createContext<initialAppData>(InitialAppData);
